// Kept free of the Regula SDK import so callers can use it without pulling Regula into their chunk.
// Source: the `Languages` union in `@regulaforensics/vp-frontend-document-components`.
const REGULA_SUPPORTED_LANGUAGES = new Set([
  "ru", "en", "de", "pl", "it", "hu", "zh", "sk", "uk", "fr", "es", "pt", "ar",
  "nl", "id", "vi", "ko", "ms", "ro", "el", "tr", "ja", "cs", "th", "hi", "bn",
  "he", "fi", "sv", "da", "hr", "no", "uz", "hy", "ky", "ku", "tg",
]);

/** Reduce an IDMe locale to its base code ("fr-CA" → "fr"); English when Regula can't render it. */
export function toRegulaLocale(language: string | null | undefined): string {
  const base = (language ?? "").split("-")[0]?.toLowerCase() ?? "";
  return REGULA_SUPPORTED_LANGUAGES.has(base) ? base : "en";
}
